// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__Yd_gm","label":"SetPasswdForm_label__18BNx"};